export enum FormatCurrencyType {
  Fiat = 'fiat',
  FiatCode = 'fiat_code',
  Crypto = 'crypto',
  None = 'none',
}
